/**
 * @enum 结算状态枚举
 */

import { SettlementStatus } from './types';

export const OrderSettlementStatusEnum: Record<string, SettlementStatus> = {
  DRAFT: {
    value: 10,
    label: '编制中',
    color: '#5476FF',
  },
  WAIT_CONFIRM: {
    value: 20,
    label: '待确认',
    color: '#FFB500',
  },
  CONFIRM: {
    value: 40,
    label: '已确认',
    color: '#00BF83',
  },
  SETTLEMENT: {
    value: 50,
    label: '已结算',
    color: '#00BF83',
  },
  REJECT: {
    value: 30,
    label: '已拒绝',
    color: '#FE3351',
  },
  INVALID: {
    value: -100,
    label: '已作废',
    color: '#656569',
  },
};

/**
 * @enum 结算管理页审批状态枚举
 */
export const SettleAuditStatusEnum: Record<string, SettlementStatus> = {
  AUDITING: {
    value: 1,
    label: '结算审批中',
    color: '#5476FF',
  },
  FAIL: {
    value: 2,
    label: '结算审批拒绝',
    color: '#FE3351',
  },
  PASS: {
    value: 3,
    label: '结算审批通过',
    color: '#00BF83',
  },
  CANCEL: {
    value: 4,
    label: '结算审批撤销',
    color: '#656569',
  },
};

export const OrderSettlementAuditTypeEnum = {
  SETTLE: { value: 0, label: '结算审批' },
  INVALID: { value: 1, label: '作废审批' },
};

/**
 * @enum 结算管理页作废审批状态枚举
 */
export const InvalidAuditStatusEnum: Record<string, SettlementStatus> = {
  INVALID_AUDITIN: {
    value: 1,
    label: '作废审批中',
    color: '#5476FF',
  },
  INVALID_FAIL: {
    value: 2,
    label: '作废审批拒绝',
    color: '#FE3351',
  },
  INVALID_PASS: {
    value: 3,
    label: '作废审批通过',
    color: '#00BF83',
  },
  INVALID_CANCEL: {
    value: 4,
    label: '作废审批撤销',
    color: '#656569',
  },
};

/**
 * @enum 发起方类型
 */
export const InitiatorTypeEnum: Record<string, Omit<SettlementStatus, 'color'>> = {
  PURCHASER: {
    value: 1,
    label: '采购商',
  },
  SUPPLIER: {
    value: 2,
    label: '供应商',
  },
};

// 标识新旧三方结算流程
export const ThirdSettTypeEnum = {
  OLD_PROCESS: 0,
  NEW_PROCESS: 1,
};

/**
 * 结算单-结算审批状态枚举
 */
export const SettlementAuditStatusEnum: Record<string, SettlementStatus> = {
  NO_AUDIT: {
    value: 0,
    label: '不需要审批',
    color: '#666',
    background: 'rgba(102, 102, 102, 0.10)',
  },
  AUDITING: {
    value: 1,
    label: '审批中',
    color: '#FA9614',
    background: 'rgba(250, 150, 20, 0.10)',
  },
  FAIL: {
    value: 2,
    label: '审批未通过',
    color: '#F44336',
    background: 'rgba(244, 67, 54, 0.10)',
  },
  PASS: {
    value: 3,
    label: '审批通过',
    color: '#3CBD30',
    background: 'rgba(60, 189, 48, 0.10)',
  },
  CANCEL: {
    value: 4,
    label: '审批撤销',
    color: '#666',
    background: 'rgba(102, 102, 102, 0.10)',
  },
};

/**
 * @enum 结算管理页审批状态枚举
 */
export const AuditStatusEnum: Record<string, SettlementStatus & { background: string }> = {
  INVALID_AUDITIN: {
    value: 21,
    label: '作废审批中',
    color: '#FA9614',
    background: 'rgba(250, 150, 20, 0.10)',
  },
  INVALID_FAIL: {
    value: 22,
    label: '作废审批拒绝',
    color: '#F44336',
    background: 'rgba(244, 67, 54, 0.10)',
  },
  INVALID_PASS: {
    value: 23,
    label: '作废审批通过',
    color: '#3CBD30',
    background: 'rgba(60, 189, 48, 0.10)',
  },
  INVALID_CANCEL: {
    value: 24,
    label: '作废审批撤销',
    color: '#666',
    background: 'rgba(102, 102, 102, 0.10)',
  },
  AUDITING: {
    value: 11,
    label: '结算审批中',
    color: '#FA9614',
    background: 'rgba(250, 150, 20, 0.10)',
  },
  FAIL: {
    value: 12,
    label: '结算审批拒绝',
    color: '#F44336',
    background: 'rgba(244, 67, 54, 0.10)',
  },
  PASS: {
    value: 13,
    label: '结算审批通过',
    color: '#3CBD30',
    background: 'rgba(60, 189, 48, 0.10)',
  },
  CANCEL: {
    value: 14,
    label: '结算审批撤销',
    color: '#666',
    background: 'rgba(102, 102, 102, 0.10)',
  },
  ADJUST_AUDITING: {
    value: 31,
    label: '调差审批中',
    color: '#5476FF',
    background: 'rgba(84, 118, 255, 0.1)',
  },
  ADJUST_FAIL: {
    value: 32,
    label: '调差审批拒绝',
    color: '#FE3351',
    background: 'rgba(244, 67, 54, 0.10)',
  },
  ADJUST_PASS: {
    value: 33,
    label: '调差审批通过',
    color: '#00BF83',
    background: 'rgba(0, 191, 131, 0.1)',
  },
  ADJUST_CANCEL: {
    value: 34,
    label: '调差审批撤销',
    color: '#656569',
    background: 'rgba(102, 102, 102, 0.10)',
  },
};

/**
 * 结算单状态枚举
 */
export const SettlementStatusEnum: Record<string, Omit<SettlementStatus, 'color'>> = {
  INVALID: {
    value: -100,
    label: '已作废',
  },
  DRAFT: {
    value: 10,
    label: '编制中',
  },
  WAIT_CONFIRM: {
    value: 20,
    label: '待确认',
  },
  REJECT: {
    value: 30,
    label: '已拒绝',
  },
  CONFIRM: {
    value: 40,
    label: '已确认',
  },
  SETTLEMENT: {
    value: 50,
    label: '已结算',
  },
};

// 结算单供应商确认状态
export const SettlementSupplierStatus: Record<string, Omit<SettlementStatus, 'color'>> = {
  CONFIRM: {
    value: 1,
    label: '同意',
  },
  REJECT: {
    value: 2,
    label: '拒绝',
  },
  SUBMIT: {
    value: 3,
    label: '提交结算单',
  },
  ESTABLISH: {
    value: 4,
    label: '创建结算单',
  },
  SUBMIT_AUDIT: {
    value: 5,
    label: '提交并发起审批',
  },
  ESTABLISH_PAYMENT_FAIL: {
    value: 6,
    label: '结算单创建支付单失败',
  },
  INVALID: {
    value: 7,
    label: '作废',
  },
  FAIL: {
    value: 10,
    label: '审批拒绝',
  },
  PURCHASE_SUBMIT_SUPPLIER: {
    value: 11,
    label: '提交供应商',
  },
  CANCEL: {
    value: 12,
    label: '撤回',
  },
  /**
   * 供应商完成在线签署
   */
  SUPPLIER_SIGN_COMPLETE: { value: 13, label: '供应商完成在线签署' },
  /**
   * 采购商完成在线签署
   */
  PURCHASER_SIGN_COMPLETE: { value: 14, label: '采购商完成在线签署' },
  /**
   * 采购商签署退回
   */
  PURCHASER_SIGN_RETURN: { value: 15, label: '采购商在线签署退回' },
  /**
   * 供应商完成解除协议签署
   */
  SUPPLIER_CANCEL_SIGN_COMPLETE: { value: 16, label: '供应商完成解除协议签署' },
  /**
   * 采购商完成解除协议签署
   */
  PURCHASER_CANCEL_SIGN_COMPLETE: { value: 17, label: '采购商完成解除协议签署' },
  /**
   * 采购商解除协议签署退回
   */
  PURCHASER_CANCEL_SIGN_RETURN: { value: 18, label: '采购商解除协议签署退回' },
  /**
   * 供应商确认作废
   */
  SUPPLIER_CONFIRM_INVALID: { value: 19, label: '供应商确认作废' },
  /**
   * 供应商拒绝作废
   */
  SUPPLIER_REJECT_INVALID: { value: 20, label: '供应商拒绝作废' },
  /**
   * 采购商上传签署文件
   */
  PURCHASER_UPLOAD_SIGN_ATTACHMENT: { value: 21, label: '采购商上传签署文件' },
  /**
   * 结算调差审批拒绝
   */
  SETTLE_ADJUST_AUDIT_REFUSE: { value: 22, label: '结算调差审批拒绝' },
  /**
   * 重新编辑
   */
  RE_EDIT: { value: 23, label: '重新编辑' },
};

export const QuoteMode = {
  WITHOUT_TAX_TYPE: {
    value: 1,
    label: '不含税',
  },
  WITH_TAX_TYPE: {
    value: 2,
    label: '含税',
  },
};

export const SettlementSignTypeEnum = {
  OFFLINE: {
    value: 10,
    label: '线下签署',
  },
  ONLINE: {
    value: 20,
    label: '在线签署',
  },
};

export const SettlementSignMethodEnum = {
  PURCHASER_AND_SUPPLIER: {
    value: 1,
    label: '采供双方签章',
  },
  ONLY_SUPPLIER: {
    value: 2,
    label: '仅供应商签章',
  },
};

export const ZyqSignStatusEnum = {
  WAIT_START: {
    value: 0,
    label: '签署待发起',
    color: '#656569',
    background: 'rgba(102, 102, 102, 0.10)',
  },
  WAIT_SIGN: {
    value: 10,
    label: '待签署',
    color: '#5476FF',
    background: 'rgba(84, 118, 255, 0.1)',
  },
  WAIT_SUPPLIER_CONFIRM: {
    value: 15,
    label: '待供应商确认',
    color: '#ffb500',
    background: 'rgba(250, 150, 20, 0.10)',
  },
  SUPPLIER_SIGN: {
    value: 20,
    label: '签署中-待供应商签署',
    color: '#ffb500',
    background: 'rgba(250, 150, 20, 0.10)',
  },
  PURCHASER_SIGN: {
    value: 30,
    label: '签署中-待采购商签署',
    color: '#ffb500',
    background: 'rgba(250, 150, 20, 0.10)',
  },
  COMPLETE: {
    value: 40,
    label: '已签署',
    color: '#00BF83',
    background: 'rgba(0, 191, 131, 0.1)',
  },
  REJECT: {
    value: 50,
    label: '签署拒绝',
    color: '#fe3351',
    background: 'rgba(244, 67, 54, 0.10)',
  },
  CANCEL: {
    value: 60,
    label: '签署撤销',
    color: '#656569',
    background: 'rgba(102, 102, 102, 0.10)',
  },
};

export const ZyqSignTypeEnum = {
  /**
   * 发起普通结算签章
   */
  SETTLEMENT: { value: 1, label: '发起普通结算签章' },

  /**
   * 发起调差结算签章
   */
  SETTLEMENT_ADJUST: { value: 2, label: '发起调差结算签章' },
  /**
   * 作废结算签章
   */
  SETTLEMENT_DISCARD: { value: 3, label: '作废结算签章' },
};

export const SettmentTypeEnum = {
  // ALL: {
  //   value: 0,
  //   label: "全部",
  // },
  MALL: {
    value: 2,
    label: '商城结算',
  },
  PROCUREMENT: {
    value: 1,
    label: '采购结算',
  },
  CONCRETE: {
    value: 3,
    label: '混凝土结算',
  },
  RENTAL: {
    value: 4,
    label: '租赁结算',
  },
  VEHICLE: {
    value: 6,
    label: '车辆结算',
  },
  SPECIAL: {
    value: 5,
    label: '专项结算',
  },
  EXPENSE: {
    value: 7,
    label: '费用结算',
  },
};

export const TenderTradeOrderTypeEnum = {
  MATCH_ORDER: {
    value: 2,
    label: '电商订单',
  },
  CONTRACT_ORDER: {
    value: 1,
    label: '传统订单',
  },
  // 2024.5.31 与李慧敏确认历史和新增类型都没有询价
  // INQUIRY_ORDER: {
  //   value: 3,
  //   label: "询价订单",
  // },
  COMPETITION_ORDER: {
    value: 4,
    label: '竞价订单',
  },
};

export const TransactionTypeEnum = {
  PURCHASE: {
    value: 1,
    label: '采购',
  },
  LEASE: {
    value: 5,
    label: '租赁',
  },
  SUB_PACKAGE: {
    value: 2,
    label: '分包',
  },
};

// 是否最终结算枚举
export const FinalSettlementListEnum = {
  DOING: {
    value: 0,
    label: '过程结算',
  },
  FINISH: {
    value: 1,
    label: '完工结算',
  },
};

// 推送三方系统状态
export const PushStatusEnum = {
  FAIL: {
    value: 0, // 包括 0 未推送，2 推送失败
    label: '未推送',
  },
  SUCCESS: {
    value: 1,
    label: '已推送',
  },
};

export const SettlementOrderEnum = {
  CONTRACT: {
    value: 10,
    label: '合同',
  },
  CONCRETE_ANALYSIS: {
    value: 20,
    label: '三算',
  },
  CAR_USAGE: {
    value: 30,
    label: '车辆使用记录',
  },
  RECEIVING: {
    value: 40,
    label: '收货单',
  },
  LEASE_RETURN: {
    value: 50,
    label: '退还单',
  },
  ORDER: {
    value: 60,
    label: '订单',
  },
  SCRAP: {
    value: 70,
    label: '报损报废单',
  },
};
export const SettlementOtherFeeTypeEnum = {
  DELIVERY: {
    value: 10,
    label: '运费',
  },
  LABOR: {
    value: 20,
    label: '力资费',
  },
  PART: {
    value: 30,
    label: '配件',
  },
  DISCARD: {
    value: 40,
    label: '报废',
  },
  COMPENSATION: {
    value: 50,
    label: '赔偿',
  },
  OFF_LEASE: {
    value: 60,
    label: '停租',
  },
  OTHER: {
    value: 70,
    label: '其他',
  },
  FEE: {
    value: 80,
    label: '罚款',
  },
  FINANCING_COST: {
    value: 90,
    label: '融资成本',
  },
};

export const PushLogStatusEnum = {
  PUSHING: {
    value: 10,
    label: '推送中',
  },
  SUCCESS: {
    value: 20,
    label: '推送成功',
  },
  FAILED: {
    value: 30,
    label: '推送失败',
  },
};

export const TransportType = {
  MATERIAL_TRANSFER: { value: 1, label: '材料调拨' },
  RENTAL_RETURN: { value: 2, label: '租赁站退料' },
  FIELD_DUMPING: { value: 3, label: '现场倒料' },
  DOMESTIC_GARBAGE: { value: 4, label: '生活垃圾' },
  CONSTRUCTION_DREGS: { value: 5, label: '建筑渣土' },
  OTHER: { value: 6, label: '其他运输' },
};
